import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import References from "@/components/site/References";
import Footer from "@/components/site/Footer";

export default function HomePage() {
    const location = useLocation();

    // Wenn wir mit einem Hash ankommen (z.B. /#leistungen), sanft scrollen
    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 60);
            }
        } else {
            window.scrollTo({ top: 0 });
        }
    }, [location]);

    return (
        <>
            <Navigation />
            <main>
                <Hero />
                <About />
                <Services />
                <WhyUs />
                <References />
            </main>
            <Footer />
        </>
    );
}
